import {useMemo} from 'react'
import casex from 'casex'

let incrementor = 1

export default function useId(prefix: string = 'use-unique-id-') {
  return useMemo(() => casex(`${prefix}-${incrementor++}`, 'ca-se'), [prefix])
}
